import { Component } from '@angular/core';
import { DatePipe, Location } from '@angular/common';
import {SettingsService} from 'src/app/services/settings.service'
import { Router ,ActivatedRoute} from '@angular/router';
import { PageEvent } from '@angular/material/paginator';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators,FormControl } from '@angular/forms'
import { ToastMsg, ToastmsgService } from 'src/app/util/toastmsg/toastmsg.service';
import { Subscription } from 'rxjs';
import {ReportingConfigService} from 'src/app/services/reporting-config.service'
import { City, Country, State, StaticdataService } from 'src/app/services/staticdata.service';
import { UserPrivilegeService } from 'src/app/services/user-privilege.service';

@Component({
  selector: 'app-reporting-config',
  templateUrl: './reporting-config.component.html',
  styleUrls: ['./reporting-config.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class ReportingConfigComponent {

  tagList:any=[]
  numbers: number[] = Array.from({ length: 25 }, (_, i) => i + 1);
  Default:any
  showDataEntity:boolean=false;
  search:any={searchText:""}
  showDataEntityPopup:boolean=false
  DataEntityRegFg!:FormGroup
  columnsDataEntityDisplay: string[] = ['expand','Name','accountCode','isEnabled'];
  columnsDatatags: string[] = ['expand','foreignSequence','tagName','required','fixedValue','displayName','granularityOverride'];
  tagName:any
  expandedElement!: any | null;
  totalElements:any=0
  action:any
  entityList:any;
  DataEntity:any=[]
  creationDate:any
  id:any='lock'
  showTags:boolean=false
  disableTag:boolean=false

  constructor(private SettingsService:SettingsService,private router:Router,private location:Location,private fb : FormBuilder, private  toastMsgService : ToastmsgService,
    private DataEntityService:ReportingConfigService,private StaticdataService:StaticdataService,private route:ActivatedRoute,
    private userPrivileges: UserPrivilegeService,
    ){
      this.userPrivileges.userPrivilegesByModule('Reporting-Config').then((privileges:any) => {
        this.privilegesValue(privileges)
      })
      .catch((error:any) => {
      console.error(error); // Handle errors, if any
      });


      this.route.queryParams.subscribe(params => {
        let data:any
        data=params
        this.id=this.SettingsService.decodeTransformed(data.id)  
        
        if(this.id==='reportingConfigNull'){
this.id=null
        }
          });
if(this.id){
  this.onClickDataEntity()

}else{
  this.onClickTags()

}
      this.dataFields()
this.stateList()
    }
    privilegesView:any
    privilegesValue(privs:any){
   
      let privileges="";
    
    if(privs.includes('view')){
      this.privilegesView="VAMD"
    }else{
      this.privilegesView="AccessDenied"
    }
    
    }

    nextPage(event:PageEvent) {
    
      let page:any = {};
      page['page'] = event.pageIndex.toString();
      page['size'] = event.pageSize.toString();
      
      //this.getAllUser(page)
    
    }
  dataFields(){
    this.DataEntityRegFg=this.fb.group({
        "address":[''],
        "phone":[''],
        "email":['',[Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)]],
        "state":[''],
        "gstType":[''],
        "entityRefId":[''],
        "gstName":[''],
        "entityGST":[''],
        "gstAccountCode":[''],
        "entityName":['',[Validators.required]],
        "accountCode":['',[Validators.required]],
        "isEnabled":['',[Validators.required]],
        "city":[''],
       "postalCode":[''],
       "type":["C"]
    });
    
  }
  closePopup() {
    this.showDataEntityPopup=false
    
    this.dataFields()
  }
  AddDataEntity(){
    

      this.DataEntityService.saveEntity(this.DataEntityRegFg.value,this.id)
      .subscribe({
        next : (res) => {
          if(res.status==200 || res.status==201) {
            this.toastMsgService.setMsg({msg : "Billing Entity Added Successfully!",msgTitle : "Success", msgType : "I"});
           
           this.showDataEntityPopup=false
           this.dataFields();
           this.dataEntitylist()

          } else {
            const body : any = res.body;
            this.registerDataEntityErrorMsg(res.status,body?.result);
          } 
  
        },error : (err) => {
  
          this.registerDataEntityErrorMsg(err.status,err.error);
        }
      }
    )
  }
  
  registerDataEntityErrorMsg(status : number,msg : string) {
    if(status >=500) {
      this.toastMsgService.setMsg({msg : "Failed to save Billing Entity",msgTitle : "Warning", msgType : "W"});
    } else {
  
      this.toastMsgService.setMsg({msg : "Failed to save Billing Entity",msgTitle:  "Warning", msgType : "W"});
    } 
  }
  
  dataEntitylist(){

     this.DataEntityService
    .listEntities(this.id)
    .subscribe({
       next : (res:any) => {
         if(res) {
        let data=res
        this.DataEntity=data
       
         } else {
        
         } 
       },error : (err) => {

     }
     }
   )
  }
  backClick(){
    this.location.back()
      }
      rowdataEntityClick(element:any){
       
        this.action="updateEntity"
        this.showDataEntityPopup=true
        this.DataEntityRegFg=this.fb.group({
          "address":[element?.address],
          "phone":[element?.phone],
          "email":[element?.email,[Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)]],
          "state":[element?.state],
          "gstType":[element?.gstType],
          "entityRefId":[element?.entityRefId],
          "gstName":[element?.gstName],
          "entityGST":[element?.entityGST],
          "gstAccountCode":[element?.gstAccountCode],
          "entityName":[element?.entityName,[Validators.required]],
          "accountCode":[element?.accountCode,[Validators.required]],
          "isEnabled":[element?.isEnabled.toString(),[Validators.required]],
          "entityId":[element?.entityId],
          "city":[element?.city],
          "postalCode":[element?.postalCode],
          "type":[element?.type]

        });
       
      }
      formatDate(val: Date) {
        let convertedValue:any = ""
        if(val){
        let datepipe = new DatePipe("en");
        //return datepipe.transform(val, "dd-MM-yyyy hh:mm:ss");
        convertedValue =  datepipe.transform(val, "dd-MM-yyyy hh:mm:ssa");
        }
        return convertedValue;
      }
     
      onAddDataEntity(){
        this.showDataEntityPopup=true
        this.action="newEntity";
      }
      onClickDataEntity(){
        this.dataEntitylist()
        this.showTags=false

      this.showDataEntity=true
      }

      onClickTags(){
        this.taglist()
        this.showDataEntity=false
        this.showTags=true
      }
      stateData:any
stateList(){
  this.StaticdataService
  .getStates()
  .subscribe({
    next : (res:any) => {
      if(res) {
     let data=res
     this.stateData=data
     console.log(this.stateData)
      } else {
      
      } 
    },error : (err) => {

    }
  }
)
}




AddNewTags(){
    
this.disableTag=true
  this.DataEntityService.saveTags(this.tagName)
  .subscribe({
    next : (res) => {
      this.disableTag=false
      console.log(res)

      
        this.toastMsgService.setMsg({msg : "Reporting Tag Added Successfully!",msgTitle : "Success", msgType : "I"});
        this.tagName=''
       this.taglist()
      
    },error : (err) => {
      this.disableTag=false
      this.registerNewtagsErrorMsg(err.status,err.error);
    }
  }
)
}

registerNewtagsErrorMsg(status : number,msg : string) {
if(status >=500) {
  this.toastMsgService.setMsg({msg : "Failed to save Reporting Tag",msgTitle : "Warning", msgType : "W"});
} else {

  this.toastMsgService.setMsg({msg : "Failed to save Reporting Tag",msgTitle:  "Warning", msgType : "W"});
} 
}


UpdateNewTags(request:any){
  request.tagValue=JSON.parse(request.tagValue)
  this.disableTag=true
    this.DataEntityService.UpdateTags(request?.tagName,request,this.id)
    .subscribe({
      next : (res) => {
        this.disableTag=false
        console.log(res)
  
        
          this.toastMsgService.setMsg({msg : "Reporting Tag Updated Successfully!",msgTitle : "Success", msgType : "I"});
          this.tagName=''
         this.taglist()
        
      },error : (err) => {
        request.tagValue=JSON.stringify(request.tagValue)
        this.disableTag=false
        this.registerUpdatetagsErrorMsg(err.status,err.error);
      }
    }
  )
  }
  
  registerUpdatetagsErrorMsg(status : number,msg : string) {
  if(status >=500) {
    this.toastMsgService.setMsg({msg : "Failed to Update Reporting Tag",msgTitle : "Warning", msgType : "W"});
  } else {
  
    this.toastMsgService.setMsg({msg : "Failed to Update Reporting Tag",msgTitle:  "Warning", msgType : "W"});
  } 
  }


taglist(){

  this.DataEntityService
 .tagList(this.id)
 .subscribe({
    next : (res:any) => {
      if(res) {
     let data:any
     data=res?.body
     this.tagList=data
    this.tagList.forEach((item:any)=>{
      item.tagValue=JSON.stringify(item.tagValue)
    })
      } else {
     
      } 
    },error : (err) => {

  }
  }
)
}
onlyNumberKey(event:any) {
     
  let charCode = (event.which) ? event.which : event.keyCode;
  if (charCode != 46 && charCode > 31
      && (charCode < 48 || charCode > 57))
      return false;
  return true;
}

copyToClipboard(item:any) {
  navigator.clipboard.writeText(item)
  this.toastMsgService.setMsg({ msg: "Text Copied !", msgTitle: "", msgType: "I" });
}
fareFields:any = [
  { key: ':fareOption1', label: 'Fare Option 1' },
  { key: ':fareOption2', label: 'Fare Option 2' },
  { key: ':fareOption3', label: 'Fare Option 3' },
  { key: ':reference', label: 'Reference' },
  { key: ':ioPidNo', label: 'IO/ PID No' },
  { key: ':indentDocNo', label: 'Indent Doc No' },
  { key: ':bookedBy', label: 'Booked By' },
  { key: ':cod3', label: 'COD 3' },
  { key: ':reasonForTravel', label: 'Reason For Travel' },
  { key: ':missedSavings', label: 'Missed Savings' },
  { key: ':globalId', label: 'Global ID' },
  { key: ':fareType', label: 'Fare Type' },
  { key: ':fareRestriction', label: 'Fare Restriction' },
  { key: ':cod1', label: 'COD 1' },
  { key: ':cod2', label: 'COD 2' },
  { key: ':cfoApprovalLessThan7Days', label: 'CFO Approval < 7 Days' },
  { key: ':billability', label: 'Billability' },
  { key: ':sapCode', label: 'SAP Code' }
];

// Sample form value for binding
formData:any = {
  fareOption1: '',
  fareOption2: '',
  fareOption3: '',
  reference: '',
  ioPidNo: '',
  indentDocNo: '',
  bookedBy: '',
  cod3: '',
  reasonForTravel: '',
  missedSavings: '',
  globalId: '',
  fareType: '',
  fareRestriction: '',
  cod1: '',
  cod2: '',
  cfoApprovalLessThan7Days: '',
  billability: '',
  sapCode: ''
};

// Clipboard method


}
